module.exports = __webpack_public_path__ + "static/media/11.537dc62d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/11.png
// module id = 928
// module chunks = 0